<template>
    <section class="margin-layout">
        <template v-if="isEdit">
            <compFormEdit
                :formdata="getDeliver"
                :changetype="changetype"
                ref="formdata"
                v-model="formData"
            ></compFormEdit>
            <vButtonGroup class="text-right">
                <vButton theme="primary" @click="handleConfirmModal">{{
                    $t("global.common.update_OK", { defaultValue: "确定" })
                }}</vButton>
                <vButton @click="cancel">{{
                    $t("global.common.return", { defaultValue: "返回" })
                }}</vButton>
            </vButtonGroup>
        </template>
        <compFormQuery
            v-else
            :formdata="getDeliver"
            :value="formData"
            placeholder="--"
        ></compFormQuery>
        <vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="closemodalprops"
            @on-confirm="confirm"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
                @on-close="closemodalprops"
            />
        </compModal>
    </section>
</template>

<script>
import {
    HttpConfirmShipment,
    HttpPackageList,
    HttpChangeShipment,
    HttpInboundBill,
    HttpGetBoatList,
} from "@/service/inbound";
import compSendGood from "./sendgood.vue";
import mixin from "../mixin";
export default {
    mixins: [mixin],
    props: ["isEdit", "value", "needBox", "activeid", "changetype", "gpNo"],
    components: {
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compModal: () => import("@components/templates/modal"),
        compSendGood,
    },
    data() {
        return {
            formData: {
                id: this.$route.query.id || this.activeid,
                isPallet: 0,
            },
            loading: false,
            hasBoxData: false,
            modalProps: {
                show: false,
            },
            boatList: [],
        };
    },
    created() {
        this.formData.gpNumber = this.gpNo;
        // 请求船公司的下拉
        HttpGetBoatList().then((res) => {
            this.boatList = res.data.map((item) => {
                return {
                    value: item.boatCompanyCode,
                    label: item.companyCnName + "(" + item.companyEnName + ")",
                };
            });
        });
    },
    mounted() {
        // console.log(!this.isEdit)
        if (!this.isEdit) {
            if (this.value.gpCartonNo20) {
                this.formData.gpSize = 1;
                this.formData.gpNumber = this.value.gpCartonNo20;
                this.formData.gpCount = this.value.gpQuantity20;
            } else if (this.value.gpCartonNo40) {
                this.formData.gpSize = 2;
                this.formData.gpNumber = this.value.gpCartonNo40;
                this.formData.gpCount = this.value.gpQuantity40;
            } else if (this.value.hqCartonNo40) {
                this.formData.gpSize = 3;
                this.formData.gpNumber = this.value.hqCartonNo40;
                this.formData.gpCount = this.value.hqQuantity40;
            } else if (this.value.hqCartonNo45) {
                this.formData.gpSize = 4;
                this.formData.gpNumber = this.value.hqCartonNo45;
                this.formData.gpCount = this.value.hqQuantity45;
            }
            this.formData = { ...this.formData, ...this.value };
        }
        // console.log(this.formData.actualArriveTime)
        if (this.formData.actualArriveTime) {
            let actualArriveTime = this.formData.actualArriveTime.replace(
                "00:00:00",
                ""
            );
            this.$set(this.formData, "actualArriveTime", actualArriveTime);
        }
        this.getPackageList();
        this.getDetail();
    },
    watch: {
        value: {
            deep: true,
            handler(val) {
                if (!this.isEdit) this.formData = { ...this.formData, ...val };
            },
        },
    },
    computed: {
        //集装箱
        isCarton() {
            return this.formData.goodsType == 2;
        },
        // 发运信息
        getDeliver() {
            return [
                {
                    label: this.$t("fbb.inbound.actualdate_shipment", {
                        defaultValue: "实际发运日期",
                    }),
                    key: "actualShipDate",
                    tag: "vDatepicker",
                    props: {
                        format: "yy-mm-dd",
                    },
                },
                {
                    label: this.$t("fbb.inbound.exped_warehousedate", {
                        defaultValue: "预计入库日期",
                    }),
                    key: "estimateArriveTime",
                    tag: "vDatepicker",
                    props: {
                        format: "yy-mm-dd",
                    },
                },
                {
                    label: this.$t("fbb.inbound.logistics_singleno", {
                        defaultValue: "物流单号",
                    }),
                    key: "tmsNo",
                },
                {
                    label: this.$t("fbb.inbound.goods_form", {
                        defaultValue: "货物形态",
                    }),
                    key: "goodsType",
                    tag: "vSelect",
                    options: this.getGoodsType,
                },
                {
                    label: this.$t("fbb.inbound.container_size", {
                        defaultValue: "集装箱尺寸",
                    }),
                    key: "gpSize",
                    tag: "vSelect",
                    options: [
                        { label: "20GP", value: 1 },
                        { label: "40GP", value: 2 },
                        { label: "40HQ", value: 3 },
                        { label: "45HQ", value: 4 },
                    ],
                    show: this.formData.goodsType == 2,
                },
                {
                    label: this.$t("fbb.inbound.container_no", {
                        defaultValue: "集装箱号",
                    }),
                    key: "gpNumber",
                    tag: "vInput",
                    // props: {
                    // 	placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
                    // },
                    show: this.formData.goodsType == 2,
                },
                // {
                //     label: '数量',
                //     key: 'gpCount',
                //     tag: 'vInputNumber',
                //     required: false,
                // 	props: {
                // 		min: 1,
                // 		math: "round"
                // 	},
                //     show: this.isCarton
                // },
                // ...(this.isCarton ? [{
                // 	label: this.$t('fbb.inbound.gpno_container',{cartonno1:'20GP',defaultValue:'20GP集装箱数量'}),
                // 	key: "gpQuantity20",
                // 	required: false,
                // 	tag: "vInputNumber",
                // 	props: {
                // 		min: 1,
                // 		math: "round"
                // 	}
                // }, {
                // 	label: this.$t('fbb.inbound.gp_number',{cartonno2:'20GP',defaultValue:'20GP集装箱号'}),
                // 	key: "gpCartonNo20",
                // 	required: false,
                // 	props: {
                // 		placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
                // 	}
                // }, {
                // 	label: this.$t('fbb.inbound.gpno_container',{cartonno1:'40GP',defaultValue:'40GP集装箱数量'}),
                // 	key: "gpQuantity40",
                // 	tag: "vInputNumber",
                // 	required: false,
                // 	props: {
                // 		min: 1,
                // 		math: "round"
                // 	}
                // }, {
                // 	label: this.$t('fbb.inbound.gp_number',{cartonno2:'40GP',defaultValue:'40GP集装箱号'}),
                // 	key: "gpCartonNo40",
                // 	required: false,
                // 	props: {
                // 		placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
                // 	}
                // }, {
                // 	label: this.$t('fbb.inbound.gpno_container',{cartonno1:'40HQ',defaultValue:'40HQ集装箱数量'}),
                // 	key: "hqQuantity40",
                // 	tag: "vInputNumber",
                // 	required: false,
                // 	props: {
                // 		min: 1,
                // 		math: "round"
                // 	}
                // }, {
                // 	label: this.$t('fbb.inbound.gp_number',{cartonno2:'40HQ',defaultValue:'40HQ集装箱号'}),
                // 	key: "hqCartonNo40",
                // 	required: false,
                // 	props: {
                // 		placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
                // 	}
                // }, {
                // 	label: this.$t('fbb.inbound.gpno_container',{cartonno1:'45HQ',defaultValue:'45HQ集装箱数量'}),
                // 	key: "hqQuantity45",
                // 	tag: "vInputNumber",
                // 	required: false,
                // 	props: {
                // 		min: 1,
                // 		math: "round"
                // 	}
                // }, {
                // 	label: this.$t('fbb.inbound.gp_number',{cartonno2:'45HQ',defaultValue:'45HQ集装箱号'}),
                // 	key: "hqCartonNo45",
                // 	required: false,
                // 	props: {
                // 		placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
                // 	}
                // }] : []),
                {
                    label: this.$t("fbb.inbound.boatcompany", {
                        defaultValue: "船公司",
                    }),
                    key: "boatCompanyCode",
                    tag: "vSelect",
                    options: this.boatList,
                    show: this.formData.goodsType == 2,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("fbb.inbound.ispallet", {
                        defaultValue: "是否打托",
                    }),
                    key: "isPallet",
                    tag: "vRadio",
                    options: [
                        {
                            trueValue: 1,
                            label: this.$t("tms.ship.correct", {
                                defaultValue: "是",
                            }),
                        },
                        {
                            trueValue: 0,
                            label: this.$t("tms.ship.deny", {
                                defaultValue: "否",
                            }),
                        },
                    ],
                },
                {
                    label: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    tag: "vTextarea",
                    key: "shipmentRemark",
                    required: false,
                },
                {
                    label: this.$t("fbb.inbound.date_warehouse", {
                        defaultValue: "到仓日期",
                    }),
                    key: "actualArriveTime",
                    query: true,
                    required: false,
                    show: !this.isEdit,
                },
                {
                    label: this.$t("fbb.inbound.arrival_date", {
                        defaultValue: "到港日期",
                    }),
                    key: "arrivePortDate",
                    query: true,
                    required: false,
                    show: !this.isEdit,
                },
            ];
        },
    },
    methods: {
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        async handleConfirmModal() {
            if (this.needBox && !this.hasBoxData) {
                this.$VMessage.warning(
                    this.$t("fbb.inbound.noship_nopacking", {
                        defaultValue: "未装箱不能发货！",
                    })
                );
                return;
            }
            const valid = await this.validFormData().catch((err) => {});
            if (!valid) return;
            // if (!this.needBox) {
            // 	this.confirm();
            // 	return
            // }
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                // title: this.$t('global.common.update_OK',{defaultValue:'确认'}),
                title: this.$t("fbb.inbound.Shipping_reminder", {
                    defaultValue: "发货提示",
                }),
                // alert: "warning",
                // desc: this.$t('fbb.inbound.confirm_updateversion',{defaultValue:'请核对并确认箱标更新为最新版本！'}),
                component: "compSendGood",
                showFooter: false,
                width: 460,
                on: {
                    "on-changeBox": () => {
                        this.$emit("on-goBoxing", { newWindow: true });
                    },
                    "on-confirm": this.confirm,
                    "on-cancel": () => {
                        this.modalProps = {};
                    },
                },
            };
        },
        // 验证formData
        async validFormData() {
            const valid = await this.$refs.formdata.validate();
            if (!valid) return;
            // const { hqCartonNo45 = '', hqQuantity45, hqCartonNo40 = '', hqQuantity40, gpCartonNo40 = '', gpQuantity40, gpQuantity20, gpCartonNo20 = '' } = this.formData;
            // const reg = /^[A-Z]{4}\d{7}$/
            // const isCarton = (hqCartonNo45 && hqQuantity45 > 0) || (hqCartonNo40 && hqQuantity40 > 0) || (gpCartonNo40 && gpQuantity40 > 0) || (gpCartonNo20 && gpQuantity20 > 0)
            const { gpSize, gpNumber } = this.formData;
            const pattern = /[A-Z]{4}\d{7}$/;
            const isCarton = gpSize && gpNumber;
            if (this.isCarton && !isCarton) {
                this.$VMessage.warning(
                    this.$t("fbb.inbound.container_fillone", {
                        defaultValue: "集装箱号,至少需要填写一组",
                    })
                );
                return;
                // this.$VMessage.warning("集装箱号必须为4位大写字母加7位数字,至少需要填写一组");
            }
            if (this.isCarton && !pattern.test(gpNumber)) {
                this.$VMessage.warning(
                    this.$t("fbb.inbound.container_number", {
                        defaultValue: "集装箱号格式为4位大写字母加7位数字",
                    })
                );
                return;
            }
            return true;
        },
        // 确认发货
        async confirm() {
            // 	const valid = await this.$refs.formdata.validate();
            // if (!valid) return this.modalProps.show = false;
            // const { hqCartonNo45 = '', hqQuantity45, hqCartonNo40 = '', hqQuantity40, gpCartonNo40 = '', gpQuantity40, gpQuantity20, gpCartonNo20 = '' } = this.formData;
            // // const reg = /^[A-Z]{4}\d{7}$/
            // const isCarton = (hqCartonNo45 && hqQuantity45 > 0) || (hqCartonNo40 && hqQuantity40 > 0) || (gpCartonNo40 && gpQuantity40 > 0) || (gpCartonNo20 && gpQuantity20 > 0)
            // if (this.isCarton && !isCarton) {
            // 	this.$VMessage.warning("集装箱号,至少需要填写一组");
            // 	// this.$VMessage.warning("集装箱号必须为4位大写字母加7位数字,至少需要填写一组");
            // 	return;
            // }
            if (this.formData.goodsType == 4 || this.formData.goodsType == 5) {
                delete this.formData.gpQuantity20;
                delete this.formData.gpCartonNo20;
                delete this.formData.gpQuantity40;
                delete this.formData.gpCartonNo40;
                delete this.formData.hqQuantity40;
                delete this.formData.hqCartonNo40;
                delete this.formData.hqQuantity45;
                delete this.formData.hqCartonNo45;
                delete this.formData.gpNumber;
            } else {
                switch (this.formData.gpSize) {
                    case 1:
                        this.formData.gpQuantity20 = 1;
                        this.formData.gpCartonNo20 = this.formData.gpNumber;
                        delete this.formData.gpQuantity40;
                        delete this.formData.gpCartonNo40;
                        delete this.formData.hqQuantity40;
                        delete this.formData.hqCartonNo40;
                        delete this.formData.hqQuantity45;
                        delete this.formData.hqCartonNo45;
                        break;
                    case 2:
                        this.formData.gpQuantity40 = 1;
                        this.formData.gpCartonNo40 = this.formData.gpNumber;
                        delete this.formData.gpQuantity20;
                        delete this.formData.gpCartonNo20;
                        delete this.formData.hqQuantity40;
                        delete this.formData.hqCartonNo40;
                        delete this.formData.hqQuantity45;
                        delete this.formData.hqCartonNo45;
                        break;
                    case 3:
                        this.formData.hqQuantity40 = 1;
                        this.formData.hqCartonNo40 = this.formData.gpNumber;
                        delete this.formData.gpQuantity20;
                        delete this.formData.gpCartonNo20;
                        delete this.formData.gpQuantity40;
                        delete this.formData.gpCartonNo40;
                        delete this.formData.hqQuantity45;
                        delete this.formData.hqCartonNo45;
                        break;
                    case 4:
                        this.formData.hqQuantity45 = 1;
                        this.formData.hqCartonNo45 = this.formData.gpNumber;
                        delete this.formData.gpQuantity20;
                        delete this.formData.gpCartonNo20;
                        delete this.formData.gpQuantity40;
                        delete this.formData.gpCartonNo40;
                        delete this.formData.hqQuantity40;
                        delete this.formData.hqCartonNo40;
                        break;
                }
            }
            if (this.changetype === "inbound") {
                return HttpChangeShipment(this.formData)
                    .then((res) => {
                        this.$VMessage.success(res.message);
                        this.modalProps.show = this.loading = false;
                        this.$emit("on-update");
                        this.cancel();
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.modalProps.show = false;
                        this.$VMessage.error(err.message);
                    });
            } else {
                return HttpConfirmShipment(this.formData)
                    .then((res) => {
                        this.$VMessage.success(res.message);
                        this.modalProps.show = this.loading = false;
                        this.$emit("on-update");
                        this.cancel();
                    })
                    .catch((err) => {
                        this.modalProps.show = this.loading = false;
                        this.$VMessage.error(err.message);
                    });
            }
        },
        getPackageList() {
            if (!this.isEdit) return;
            HttpPackageList({
                page: 1,
                rows: 1,
                sidx: "id",
                sord: "desc",
                id: this.formData.id,
            })
                .then((res) => {
                    const content = (res.data || {}).content || [];
                    this.hasBoxData = !!content.length;
                })
                .catch((err) => {
                    this.hasBoxData = false;
                });
        },
        getDetail() {
            if (this.changetype == "inbound") {
                HttpInboundBill({ id: this.formData.id })
                    .then((res) => {
                        this.loading = false;
                        this.formData = res.data;
                        if (res.data.gpCartonNo20) {
                            this.formData.gpSize = 1;
                            this.formData.gpNumber = res.data.gpCartonNo20;
                        } else if (res.data.gpCartonNo40) {
                            this.formData.gpSize = 2;
                            this.formData.gpNumber = res.data.gpCartonNo40;
                        } else if (res.data.hqCartonNo40) {
                            this.formData.gpSize = 3;
                            this.formData.gpNumber = res.data.hqCartonNo40;
                        } else if (res.data.hqCartonNo45) {
                            this.formData.gpSize = 4;
                            this.formData.gpNumber = res.data.hqCartonNo45;
                        }
                        this.$set(
                            this.formData,
                            "serviceCodes",
                            this.formData.serviceCode
                        );
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            }
        },
        cancel() {
            this.$emit("on-cancel");
            this.$emit("on-close");
        },
    },
};
</script>
